<template>
  <div class="nameplate-container">
    <div
      v-if="!rendering"
      class="image-container"
    >
      <img
        v-if="imageUrl"
        :src="image"
        class="hvac-image"
        alt="HVAC photo"
        role="button"
        tabindex="0"
        @click="openImage"
        @keydown.enter.prevent="openImage"
        @keydown.space.prevent="openImage"
      >
      <div
        v-else
        class="no-image"
      >
        No Image
      </div>
    </div>
    <div
      v-else
      class="loading-container"
    >
      <img
        src="@shared/assets/img/general/loading.svg"
        alt="processing"
        class="p-spinner"
      >
    </div>
    <button
      v-if="nameplateOption && adminRole !== 'viewer'"
      type="button"
      class="upload-btn"
      @click="change(true, 'request-nameplate', cHvac)"
    >
      Request New Picture
    </button>
    <button
      v-if="uploadOption && adminRole !== 'viewer'"
      type="button"
      class="upload-btn"
      @click="change(true, 'upload-image', cHvac)"
    >
      {{ uploadText || 'Upload New Picture' }}
    </button>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'HvacImage',
  mixins: [customerDetailMixin],
  props: {
    imageUrl: String,
    change: Function,
    uploadOption: Boolean,
    nameplateOption: Boolean,
    uploadText: String,
    cHvac: Object,
  },
  data() {
    return {
      image: '',
      rendering: false,
    };
  },
  watch: {
    async imageUrl() {
      await this.updatingImage();
    },
  },
  async mounted() {
    if (this.imageUrl) {
      await this.updatingImage();
    }
  },
  methods: {
    openImage() {
      const location = {
        path: '/image',
        query: { src: this.imageUrl },
      };
      const route = this.$router.resolve(location);
      const newTab = window.open(route.href, '_blank');
      if (!newTab) {
        this.$router.push(location);
        return;
      }
      newTab.opener = null;
    },

    async updatingImage() {
      this.rendering = true;
      this.image = await this.$store.dispatch('getImageResponse', {
        url: this.imageUrl,
      });
      this.rendering = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.nameplate-container {
  display: grid;
  justify-content: center;
  .image-container {
    justify-self: center;
    .hvac-image {
      height: 100px;
      width: 150px;
    }
    .no-image {
      height: 100px;
      width: 150px;
      border-radius: 4px;
      background-color: $N20;
      font-size: 14px;
      font-weight: 500;
      display: grid;
      align-items: center;
      justify-content: center;
    }
  }
  .upload-btn {
    text-decoration: underline;
    color: $NBLUE100;
    font-weight: 600;
    margin-top: 1rem;
  }
}
</style>
